import snakecaseKeys from 'snakecase-keys';
export function encodeMultipartManifest(manifest) {
    const json = JSON.stringify(snakecaseKeys(manifest, { deep: true }));
    const binary = Array.from(new TextEncoder().encode(json), (byte) => String.fromCharCode(byte)).join('');
    return btoa(binary);
}
